import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { SubProjectTourInfo } from '../helper/model/sub-project-tour-info';
import { Observable } from 'rxjs';
import { _get } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SubProjectTourInfoControllerRequestService {
  private static BASE_URL = '/tours/subProjectTourInfo';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as SubProjectTourInfo;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      SubProjectTourInfoControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public subProjectTourInfo(subProjectId: number): Promise<SubProjectTourInfo> {
    return this.get(`/${subProjectId}`, this.deserialize).toPromise();
  }
}
